/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-restricted-globals */
import { FC } from "react";
import { Button } from "../../forms/components/Button";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import { useNavigate } from "../../common/hooks/useNavigate";

export const TryAgainButton: FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Button
        className="tw-px-6"
        data-testid={DataTestids.TryAgainButton}
        onClick={() => {
          // Reload the page for check status API return
          navigate(0);
        }}
      >
        Try again
      </Button>
    </>
  );
};
